import { get } from '../../../../shared/utils/http';

import { initialiseCommonStore } from '../../../../shared/components/react/CommonDataStore/actions';

import { COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS } from '../../../../shared/components/react/CommonDataStore/actionTypes';

import { parseDate } from '../utils';

import exponentialBackoff from '../../../../shared/utils/exponential-backoff';

import { buildSpectateUrl } from '../../../../spa/Utils/Spectate';

/**
 * @todo Removed redundant action creators.
 */
import {
    BETFEED_REFRESH,
    BETFEED_LOADING,
    BETFEED_LOADING_ERROR,
    BETFEED_LOADING_SUCCESS,
    BETFEED_START_LISTENING_FOR_WS_UPDATES,
    BETFEED_STOP_LISTENING_FOR_WS_UPDATES,
    BETFEED_NEW_BETS,
    BETFEED_ACTIVE_FILTER,
    BETFEED_SELECT_FILTER_OPTION,
    BETFEED_RESET_FILTERS,
    BETFEED_START_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES,
    BETFEED_STOP_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES,
    BETFEED_NUMBER_OF_PEOPLE_BET_UPDATE_FROM_WEBSOCKET_EVENTS,
    BETFEED_SPORT_FILTERS,
} from './betfeedActionTypes';

import mainSocket from '../../../../shared/services/mainSocketClass';
import betfeedSocket from '../betfeedSocket';
import {
    BB_BETFEED_ENDPOINT,
    BB_BETFEED_LAST_TIMESTAMP_ENDPOINT,
    BB_BETFEED_NEW_BETS_TIME_DELAY_IN_MILLI_SECONDS,
    BB_BETFEED_GET_BETABLE_SPORT_FILTER_ENDPOINT,
    BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
} from '../../constants';

import { isBetfeedPageEnabled } from '../utils';

export const refresh = () => {
    return { type: BETFEED_REFRESH };
};

export const betfeedLoading = bool => {
    return {
        type: BETFEED_LOADING,
        status: bool,
    };
};

export const betcardsLoadSuccess = betCards => {
    return {
        type: BETFEED_LOADING_SUCCESS,
        betCards,
    };
};

export const betcardsErrorOccurred = bool => {
    return {
        type: BETFEED_LOADING_ERROR,
        errorOccurred: bool,
    };
};

export const startListeningForWsUpdates = (betCards) => {
    return {
        type: BETFEED_START_LISTENING_FOR_WS_UPDATES,
        betCards,
    };
};

export const stopListeningForWsUpdates = betCards => {
    return {
        type: BETFEED_STOP_LISTENING_FOR_WS_UPDATES,
        betCards,
    };
};

/**
 * Start listening for updates
 * Important: The start/stopListeningForWsNumberOfPeopleBettedUpdates DOES NOT
 * implement subscription tracking and the order of calls is important (i.e. unregister
 * for updates before registering)
 * @todo If we ever get 2 widgets on a single page calling start/stopListeningForWsNumberOfPeopleBettedUpdates
 * we must implement subscription tracking
 * @param {Array} betCards betcards
 * @returns {Object} React action
 */
export const startListeningForWsNumberOfPeopleBettedUpdates = (betCards) => {
    return {
        type: BETFEED_START_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES,
        betCards,
    };
};

/**
 * Stop listening for updates
 * @see startListeningForWsNumberOfPeopleBettedUpdates()
 * @param {Array} betCards betcards
 * @returns {Object} React action
 */
export const stopListeningForWsNumberOfPeopleBettedUpdates = (betCards) => {
    return {
        type: BETFEED_STOP_LISTENING_FOR_WS_NUMBER_OF_PEOPLE_BETTED_UPDATES,
        betCards,
    };
};

export const updateCommonStoreWsData = wsData => {
    return {
        type: COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS,
        wsData: wsData,
    };
};

export const updateNumberOfPeopleBetsWsData = wsData => {
    return {
        type: BETFEED_NUMBER_OF_PEOPLE_BET_UPDATE_FROM_WEBSOCKET_EVENTS,
        wsData: wsData,
    };
};

export const newBets = bool => {
    return {
        type: BETFEED_NEW_BETS,
        status: bool,
    };
};

let existedNewBetsTimer = null;

export const betsTimestamp = async (dispatch) => {
    const one = 1;
    let numOfAttempts = one;
    const maxNumOfAttempts = 5;
    const minRetryDelay = 3000;
    const maxRetryDelay = 15000;

    if (existedNewBetsTimer !== null) {
        clearTimeout(existedNewBetsTimer);
    }

    let cardsTimeStamp = null;

    /**
     * gets last bets timestamp from server, if errors response from server, we retry until max attemps reach,
     * we use the Exponential Backoff to avoid flooding the server
     * @returns {void}
     */
    async function getLastBetsTimestamp() {
        let delay = BB_BETFEED_NEW_BETS_TIME_DELAY_IN_MILLI_SECONDS;
        const response = await get(
            buildSpectateUrl(BB_BETFEED_LAST_TIMESTAMP_ENDPOINT),
            getBetcardsAjaxGetOptions()
        );
        if (response.ok) {
            const data = await response.json();
            numOfAttempts = one;
            if (data !== null) {
                const lastBetReceived = parseDate(data.last_bet_received).getTime();
                if (cardsTimeStamp && cardsTimeStamp < lastBetReceived) {
                    dispatch(newBets(true));
                    cardsTimeStamp = lastBetReceived;

                    return;
                }
                cardsTimeStamp = lastBetReceived;
            }
        } else if (numOfAttempts++ <= maxNumOfAttempts) {
            delay = exponentialBackoff(numOfAttempts, minRetryDelay, maxRetryDelay).toFixed();
        } else {
            return;
        }
        existedNewBetsTimer = setTimeout(getLastBetsTimestamp, delay);
    }

    await getLastBetsTimestamp();
};

const getBetcardsAjaxGetOptions = () => {
    return {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
    };
};

/**
 * Fetch betcards from backend
 * @param {function} wsEventListener callback for websocket updates
 * @param {function} wsEventListenerNumberOfPeopleBets callback for websocket updates
 * @returns {array} array of betcard objects
 */
export const getBetCards = (wsEventListener, wsEventListenerNumberOfPeopleBets) => {

    return async (dispatch, getState) => {
        dispatch(newBets(false));
        dispatch(betcardsErrorOccurred(false));

        if (!isBetfeedPageEnabled()) {
            dispatch(betcardsErrorOccurred(true));

            return;
        }

        try {
            const state = getState();
            const { sortBy: { id : sorting }, sports, eventStatus, betType } = state.betcards.filter.selected;
            let endPoint = buildSpectateUrl(
                `${BB_BETFEED_ENDPOINT}?sorting=${sorting}`
            );
            if (sports && Object.keys(sports).length) {
               endPoint += `&sports=[${Object.keys(sports).join(',')}]`;
            }

            if (eventStatus.id !== BB_BETFEED_FILTER_BET_TYPES_DEFAULT.id) {
                endPoint += `&event_status=${eventStatus.id}`;
            }

            if (betType.id !== BB_BETFEED_FILTER_BET_TYPES_DEFAULT.id) {
                endPoint += `&bet_type=${betType.id}`;
            }

            const response = await get(endPoint, getBetcardsAjaxGetOptions());
            if (!response.ok) {
                dispatch(betcardsErrorOccurred(true));

                return;
            }
            const data = await response.json();

            dispatch([
                initialiseCommonStore(data.events),
                betcardsLoadSuccess(data),
            ]);

            const betcards = state.betcards.betCards;
            if (Array.isArray(betcards) && betcards.length) {
                dispatch(stopListeningForWsUpdates({betcards}));
                dispatch(stopListeningForWsNumberOfPeopleBettedUpdates({betcards}));
            }

            dispatch(startListeningForWsUpdates(data));
            dispatch(startListeningForWsNumberOfPeopleBettedUpdates(data));

            mainSocket.onWsEventUpdate(wsEventListener);
            betfeedSocket.onWsEventUpdate(wsEventListenerNumberOfPeopleBets);
            await betsTimestamp(dispatch);
        } catch (e) {
            dispatch(betcardsErrorOccurred(true));
        }
    };
};

export const getSportFilter = () => {
    return async (dispatch) => {
        try {
            const response = await get(
                buildSpectateUrl(BB_BETFEED_GET_BETABLE_SPORT_FILTER_ENDPOINT),
                getBetcardsAjaxGetOptions()
            );
            if (response.ok) {
                const data = await response.json();
                dispatch(sportFilter(data));
            }
        } catch (e) {
            dispatch(betcardsErrorOccurred(true));
        }
    };
};

export const sportFilter = (sports) => {
    return {
        type: BETFEED_SPORT_FILTERS,
        sports,
    };
};

export const activeFilter = (active) => {
    return {
        type: BETFEED_ACTIVE_FILTER,
        active,
    };
};

export const selectFilterOption = (filter, id) => {
    return {
        type: BETFEED_SELECT_FILTER_OPTION,
        filter,
        id,
    };
};

export const resetFilters = (filter) => {
    return {
        type: BETFEED_RESET_FILTERS,
        filter,
    };
};
